import { render, staticRenderFns } from "./CompatibleLessonForm.vue?vue&type=template&id=36fa87e4&scoped=true&"
import script from "./CompatibleLessonForm.vue?vue&type=script&lang=js&"
export * from "./CompatibleLessonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fa87e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
